import request from '@/axios/index.js'
const uri = '/user/loan/';
export function financeQuery(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri + 'query'
    })
}
export function getPrincipal(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+"getPrincipal"
    })
}
export function fncInfo(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: uri+"fncInfo"
    })
}

export function repayView(data,loading) { //贷后详情
    return request.axios({
        loading:loading,
        data:data,
        url: uri+"repayView"
    })
}



// WEBPACK FOOTER //
// ./src/api/loan.js